import { render } from "./cadastro_seguro.vue?vue&type=template&id=c98c00d2&scoped=true"
import script from "./cadastro_seguro.vue?vue&type=script&lang=js"
export * from "./cadastro_seguro.vue?vue&type=script&lang=js"

import "./cadastro_seguro.vue?vue&type=style&index=0&id=c98c00d2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98c00d2"]])

export default __exports__